module.exports = "query ($id: ID!) {\n  Draft(id: $id) {\n    ...BaseDraft\n  }\n}\n\nfragment BaseDraft on Draft {\n  id\n}\n"